// © 2026 Camp Promethean, LLC. All Rights Reserved.

import type { NavItem } from "@/types/navigation";

/** Camp Promethean app administrators (`profiles.role = admin`). */
export function isPlatformAdmin(role: string | null | undefined): boolean {
  return role === "admin";
}

export const ADMIN_ONLY_PATH_PREFIXES = [
  "/agora",
  "/ancora/courses",
  "/ancora/certifications",
  "/ancora/recruiting-tool",
  "/aurum",
  "/atlas/calendar",
  "/atlas/production",
] as const;

export function isAdminOnlyNavPath(path: string): boolean {
  return ADMIN_ONLY_PATH_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`),
  );
}

/** Admin-preview modules shown as Coming Soon to non-admins (still route-blocked). */
export function isComingSoonNavPath(path: string): boolean {
  return (
    path === "/agora" ||
    path.startsWith("/agora/")
  );
}

export function filterNavItemsForRole(items: NavItem[], admin: boolean): NavItem[] {
  return items
    .filter(
      (item) => !item.adminOnly || admin || isComingSoonNavPath(item.path),
    )
    .map((item) =>
      item.children
        ? { ...item, children: filterNavItemsForRole(item.children, admin) }
        : item,
    );
}
